/**
 * Form action types enum
 */
export var FormActionTypes;
(function (FormActionTypes) {
    FormActionTypes["SET_STEP"] = "SET_STEP";
    FormActionTypes["SET_REGO_DETAILS"] = "SET_REGO_DETAILS";
    FormActionTypes["SET_VEHICLE_DETAILS"] = "SET_VEHICLE_DETAILS";
    FormActionTypes["SET_MANUAL_LOOKUP_DETAILS"] = "SET_MANUAL_LOOKUP_DETAILS";
    FormActionTypes["SET_ENTRY_METHOD"] = "SET_ENTRY_METHOD";
    FormActionTypes["SET_EXCLUSION_STATUS"] = "SET_EXCLUSION_STATUS";
    FormActionTypes["SET_PREVIOUS_SESSION"] = "SET_PREVIOUS_SESSION";
    FormActionTypes["RESET_FORM"] = "RESET_FORM";
})(FormActionTypes || (FormActionTypes = {}));
